import React, { useState } from "react";
import layoutStyles from "../PanelUser/PanelLayout.module.css";
import styles from "./Dependientes.module.css";
import axiosInstance from "../../api/axiosConfig";
import {
  PanelSidebar,
  PanelHeader,
  useUserData,
  formatDate,
  MOCK_USER,
} from "../PanelUser/PanelShared";
import { Link } from "react-router-dom";

const MOCK_DEPENDIENTES = [
  {
    id: 1,
    name: "María",
    lastName: "García",
    relationship: "Cónyuge",
    age: 32,
    birthdate: "1993-06-14",
    dni: "45678901",
    lastConsult: "2026-02-16",
    citas: 4,
  },
  {
    id: 2,
    name: "Diego",
    lastName: "García",
    relationship: "Hijo",
    age: 8,
    birthdate: "2017-11-03",
    dni: "87654321",
    lastConsult: "2026-01-08",
    citas: 2,
  },
];

function getInitials(a = "", b = "") {
  return `${a[0] || ""}${b[0] || ""}`.toUpperCase() || "?";
}

const COLORS = ["#2db899", "#1a3a5c", "#f59e0b", "#6366f1"];

export default function Dependientes() {
  const user = useUserData(axiosInstance) || MOCK_USER;
  const [selected, setSelected] = useState(null);

  return (
    <div className={layoutStyles.panelPage}>
      <PanelSidebar user={user} />

      <main className={layoutStyles.main}>
        <PanelHeader label="Mi panel" title="Dependientes" user={user} />
        <p className={styles.subtitle}>Gestioná los familiares vinculados a tu cuenta.</p>

        <div className={styles.twoCol}>
          {/* Lista */}
          <div>
            {/* Cards de dependientes */}
            <div className={styles.depList}>
              {MOCK_DEPENDIENTES.map((dep, i) => (
                <div
                  key={dep.id}
                  className={`${styles.depCard} ${selected?.id === dep.id ? styles.depCardActive : ""}`}
                  onClick={() => setSelected(dep)}
                >
                  <div
                    className={styles.depAvatar}
                    style={{ background: COLORS[i % COLORS.length] }}
                  >
                    {getInitials(dep.name, dep.lastName)}
                  </div>
                  <div className={styles.depInfo}>
                    <p className={styles.depName}>
                      {dep.name} {dep.lastName}
                    </p>
                    <p className={styles.depMeta}>
                      {dep.relationship} · {dep.age} años
                    </p>
                    <p className={styles.depMeta}>Última consulta: {formatDate(dep.lastConsult)}</p>
                  </div>
                  <div className={styles.depStats}>
                    <p className={styles.depStatVal}>{dep.citas}</p>
                    <p className={styles.depStatLbl}>citas</p>
                  </div>
                </div>
              ))}

              {/* Agregar dependiente */}
              <Link to="/registrar-usuario" className={styles.addCard}>
                <span className={styles.addIcon}>+</span>
                <div>
                  <p className={styles.addTitle}>Agregar dependiente</p>
                  <p className={styles.addSub}>Vinculá un familiar para gestionar sus citas</p>
                </div>
              </Link>
            </div>
          </div>

          {/* Detalle */}
          <div className={layoutStyles.card}>
            {!selected ? (
              <p className={layoutStyles.emptyState}>
                Seleccioná un dependiente para ver el detalle.
              </p>
            ) : (
              <div className={styles.detail}>
                <div className={styles.detailTop}>
                  <div
                    className={styles.detailAvatar}
                    style={{
                      background:
                        COLORS[
                          MOCK_DEPENDIENTES.findIndex((d) => d.id === selected.id) % COLORS.length
                        ],
                    }}
                  >
                    {getInitials(selected.name, selected.lastName)}
                  </div>
                  <div>
                    <p className={styles.detailName}>
                      {selected.name} {selected.lastName}
                    </p>
                    <p className={styles.detailRel}>{selected.relationship}</p>
                  </div>
                </div>

                <div className={styles.detailRow}>
                  <span>DNI</span>
                  <strong>{selected.dni || "—"}</strong>
                </div>
                <div className={styles.detailRow}>
                  <span>Fecha de nacimiento</span>
                  <strong>{formatDate(selected.birthdate)}</strong>
                </div>
                <div className={styles.detailRow}>
                  <span>Edad</span>
                  <strong>{selected.age} años</strong>
                </div>
                <div className={styles.detailRow}>
                  <span>Última consulta</span>
                  <strong>{formatDate(selected.lastConsult)}</strong>
                </div>
                <div className={styles.detailRow}>
                  <span>Total citas</span>
                  <strong>{selected.citas}</strong>
                </div>

                <div className={styles.detailActions}>
                  <Link to="/" className={styles.btnNuevaCita}>
                    Nueva cita para este dependiente
                  </Link>
                  <button className={styles.btnEliminar}>Desvincular</button>
                </div>
              </div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
}
